import { coveragesSpecialEquipment, catVehicleBrand, catVehicleDevice } from './MochaData'
import { SitioOportunity } from '../../../utils/global'
import  { GetResumenRate} from '../../../utils/helpMain'

const IsValidString = (val: string) => (val !== '' && val !== undefined && val !== null);
const isValidObject = (obj: any) => (obj !== undefined && obj !== null);
const formatNumber = (val: number) => Intl.NumberFormat().format(val);
const roundToTwo = (value: number, decimals = 2): number => (Number(Math.round(parseFloat(value.toString() + 'e' + decimals)) + 'e-' + decimals));

const optionsUsd = { style: 'currency', currency: 'USD', numberingSystem: "latn" };
const optionsColon = { style: 'currency', currency: 'CRC', numberingSystem: "latn" };
const numberFormatUsd = new Intl.NumberFormat('en-US', optionsUsd);
const numberFormatColon = new Intl.NumberFormat('es-CR', optionsColon);

const formatMoney = (currency: string, value: number) => (currency.trim() === '¢') ? numberFormatColon.format(value) : numberFormatUsd.format(value)


const GetDataByListPolicy = (data: IAutoCR) => {
    return {
        "type": data.searchFilter,
        "data": data.filterData,
        "producer": data.idBrokerage,
        "status": 0
    }
}

const GetDataRates = (data: IAutoCR) => {

    const plan = data.lstPlanConfig.find(x => x.id === parseInt(data.plan))

    const dataRates: Record<string, any> = {
        itipopol: 'I',
        VigenciaPol: 'A',
        valn: data.vehicleValue,
        mode: data.vehicleModel,
        marca: data.vehicleBrand === '0' ? data.otherVehicleBrand : data.vehicleBrand,
        marc: data.vehicleBrand === '0' ? data.otherVehicleBrand : data.vehicleBrand,
        anio: data.vehicleYear,
        usoo: data.vehicleUse,
        suma: data.vehicleValue,
        cate: data.datasheet.auCategoria,
        nasiento: data.datasheet.auNumPasajeros,
        tipo: data.datasheet.auTipo,
        valnreal: data.vehicleValue,
        dedu: data.deductible,
        rsat: data.vehicleDevice
    }

    let coverageIdsStr = "[";

    data.lstCoverageExt.map((x: ICoveragesExt) => {
        if (x.obligatoria || x.checked) {
            dataRates[`Cob${x.idCob}`] = 1;
            coverageIdsStr = coverageIdsStr + `${x.idCob},`;
            if (x.sa?.length > 0)
                dataRates[`CobSA${x.idCob}`] = x.sa
            if (isSpecialEquipment(x.idCob))
                dataRates['SumEE'] = x.kitSpecialSA;
        }
        else
            dataRates[`Cob${x.idCob}`] = 0
    })

    coverageIdsStr = coverageIdsStr.substring(0, coverageIdsStr.length - 1) + "]";
    dataRates["coverageIds"] = coverageIdsStr;

    plan?.descuentos.forEach((x: number) => {
        dataRates[`codigo${x}`] = 0
    })

    if (data.idDiscount > 0)
        dataRates[`codigo${data.idDiscount}`] = 1
    if (data.idDiscount === 2)
        dataRates['desManualValue'] = data.discount;

    return dataRates;
}

const GetResumen = (data: IAutoCR) => {
    let coveragesDetail: Array<IRatesTable> = [];
    let bonusTax: number = 0;

    const planConfig = data.lstPlanConfig.find(x => x.id === parseInt(data.plan));
    if (planConfig === undefined || planConfig === null) return {} as IRatesResumen;
    const currency = planConfig.moneda;

    let financing: number = 0;

    let rightEmission: number = roundToTwo(bonusTax * (planConfig.porcentajeGasto / 100));
    if (rightEmission < planConfig.gastoMontoMinimo)
        rightEmission = planConfig.gastoMontoMinimo;
    if (rightEmission > planConfig.gastoMontoMaximo)
        rightEmission = planConfig.gastoMontoMaximo;

    let taxFinancing = planConfig.intereses ?? undefined;

    let bonus = roundToTwo(data.rates['rates'].map((x: any) => ({ ...x, prima: roundToTwo(x.prima) + roundToTwo((x.prima * x.pRecargo) / 100) })).sum('prima'));
    let desc = 0;

    data.rates['rates'].map((rate: IRates) => {
        let nameCover = data.lstCoverageExt.find(x => x.idCob === rate.idCob);
        if (nameCover !== undefined) {
            let insuredMount = roundToTwo(parseFloat(rate.prima) * ((rate.pRecargo / 100) + 1));
            let det: IRatesTable = {
                name: nameCover.nombre,
                insured: formatMoney(currency, insuredMount),
                sa: rate.sa,
                value: formatMoney(currency, parseFloat(rate.sa))
            };
            coveragesDetail.push(det);

            if (nameCover.bImpuesto1)
                bonusTax = bonusTax + insuredMount;

            let porcenDescount = 0;
            if (rate.descuentos.length > 0) {
                let descAp = rate.descuentos.find((x: any) => x.codigoDescuento === data.idDiscount)
                if (descAp !== undefined) {
                    porcenDescount = descAp.porcentaje;
                }
                else {
                    porcenDescount = rate.descuentos[0].porcentaje;
                }
            }

            if (porcenDescount > 0) {
                let prima = parseFloat(rate.prima);
                desc = desc + roundToTwo((roundToTwo(prima) + roundToTwo((prima * rate.pRecargo) / 100)) * (porcenDescount / 100))
            }
        }
    });



    let bonusDE = roundToTwo(bonusTax - desc);
    let bonus2 = roundToTwo(bonus - desc);

    if (taxFinancing !== undefined) {
        let taxP = taxFinancing.find((x: any) => x.frecuenciaPago === (data.quotas === '' ? 0 : parseInt(data.quotas)));
        if (taxP !== undefined)
            financing = roundToTwo((bonus2 * (parseFloat(taxP.porcentajeInteres) / 100)));
    }


    let tax = roundToTwo((bonusTax - desc) * (planConfig.impuestos.interes / 100));
    let total = roundToTwo(bonus2 + tax + financing + rightEmission);

    let catBonusFrecuenia: Array<ICatalog> = data.catQuotas.map((x: ICatalog) => {
        return {
            text: x.text,
            value: formatMoney(currency, (bonus2 + tax + GetFinancing(taxFinancing, bonus2, x.value) + rightEmission) / parseInt(x.value))
        } as ICatalog
    })

    let result: IRatesResumen = {
        coveragesDetail: coveragesDetail,
        bonus: bonus,
        desc: desc,
        bonus2: bonus2,
        tax: tax,
        financing: financing,
        total: total,
        bonusDE: bonusDE,
        rightEmission: rightEmission,

        bonusStr: formatMoney(currency, bonus),
        descStr: formatMoney(currency, desc),
        bonus2Str: formatMoney(currency, bonus2),
        taxStr: formatMoney(currency, tax),
        financingStr: formatMoney(currency, financing),
        totalStr: formatMoney(currency, total),

        bonusAnnual: '',
        bonusSemester: '',
        bonusQuarterly: '',
        bonusMonthly: '',
        bonusFrecuencia: 0,

        rightEmissionsStr: numberFormatUsd.format(rightEmission),
        bonusfrequency: catBonusFrecuenia
    }
    return result;
}

const BuilData = (data: IAutoCR, source: string | null) => {

    let lstBeneficiary: any = [];
    let lstAnswers: any = [];
    let polCobs: any = [];
    let polCobsDesc: any = [];
    let lstOAKitSpecial: Array<OA_EquipoEspecial> = [];
    let oa: any = {}


    //const resumen = GetResumen(data);
    const resumen = GetResumenRate({
            plan: data.lstPlanConfig.find((x: any) => x.id === parseInt(data.plan)) ?? { id: 0, name: '', description: '', maxDayPlan: 0 } as any,
            catQuotas: data.catQuotas,
            idDiscount: data.idDiscount,
            lstCoverageExt: data.lstCoverageExt,
            lstRates: data.rates.rates,
            nQuotas: data.quotas ?? '',
            sumInsured: data.vehicleValue
        });
    const Frecuency = data.catQuotas.find(x => x.value === data.quotas)?.text2 ?? ''

    let policy: any = {
        Plan: data.plan,
        SA: data.vehicleValue,
        Prima: resumen.bonus,
        Descuento: resumen.desc,
        PrimaDE: resumen.bonus,
        PrimaNeta: resumen.bonus2,
        PrimaExonerada: 0,
        Impuesto: resumen.tax,
        Total: resumen.total,
        Frecuencia: Frecuency,
        Cuotas: data.quotas,
        Estado: 0,
        mInteres: resumen.financing,
        DerechoEmision: resumen.rightEmission,
        Source: source,
        Usuario: data.username,
        id: data.idPoliza,
        SubAgente: data.idUser,
        IdSitio: SitioOportunity.CR.AutoCorreduria
    }

    let auMarcaDesc = {} as ICatalog | undefined;

    if (data.vehicleBrand === '0')
        auMarcaDesc = data.catBranch.find((x: any) => x.value === data.otherVehicleBrand.trim());
    else
        auMarcaDesc = catVehicleBrand.find(x => x.value === data.vehicleBrand)
    let auModeloDesc = data.catModel.find((x: any) => x.value === data.vehicleModel.trim());


    let au = {
        SA: data.vehicleValue,
        auMarca: auMarcaDesc?.text.toUpperCase(),
        auModelo: auModeloDesc?.text.toUpperCase(),
        auAnio: data.vehicleYear,
        auCategoria: data.datasheet.auCategoria,
        auValorNuevo: data.vehicleValue,
        auNumPasajeros: data.datasheet.auNumPasajeros,
        auUso: data.vehicleUse,
        auGPS: false,
        auNuevo: data.vehicleStatus === "1" ? true : false,
        codigoMarca: data.vehicleBrand === '0' ? data.otherVehicleBrand : data.vehicleBrand,
        codigoModelo: data.vehicleModel,
        ideducible: data.deductible,
        irastreoSatelital: data.vehicleDevice
    };

    let insured = {
        TipoId: data.typeDocumentInsured,
        NumId: data.identificationInsured,
        Nombre: data.firstName,
        Apellido: data.lastName,
        TelefonoCelular: data.phone,
        Email: data.mail.trim(),
        EstadoCivil: data.civilStatus,
        Sexo: data.sex
    }


    data.rates['rates'].map((rate: IRates) => {
        let nameCover = data.catCoverage.coverages.find(x => x.idCob === rate.idCob);
        let tempCover: any = {};

        let prima = roundToTwo(validPrima(rate.prima) * ((rate.pRecargo / 100) + 1));
        let primaDE = 0;
        let pRecargo = 0;
        let mRecargo = 0;


        if (nameCover !== undefined) {

            let porcenDescount = 0;
            let desc = 0
            let idDesc = 0;
            if (rate.descuentos.length > 0) {
                let descAp = rate.descuentos.find((x: any) => x.codigoDescuento === data.idDiscount)
                if (descAp !== undefined) {
                    porcenDescount = descAp.porcentaje;
                    idDesc = descAp.codigoDescuento
                }
                else {
                    porcenDescount = rate.descuentos[0].porcentaje;
                    idDesc = rate.descuentos[0].codigoDescuento
                }
            }

            if (rate.pRecargo > 0) {
                pRecargo = rate.pRecargo;
                mRecargo = roundToTwo(validPrima(rate.prima) * ((rate.pRecargo / 100)));
            }

            if (porcenDescount > 0) {
                let primaDesc = validPrima(rate.prima);
                desc = roundToTwo((prima) * (porcenDescount / 100))
            }

            primaDE = roundToTwo(prima - desc);


            let Etiqueta = '0';
            let cobExt = data.lstCoverageExt.find(x => x.idCob === rate.idCob)

            if (cobExt !== undefined && cobExt !== null) {
                if (cobExt.catalog.length > 0)
                    Etiqueta = cobExt.sa;
                if (isSpecialEquipment(rate.idCob)) {
                    let kitSpecial: OA_EquipoEspecial = {
                        id: 0,
                        OA_Id: 0,
                        Tipo: 1,
                        Valor: cobExt.kitSpecialSA?.toString(),
                        Observaciones: cobExt.kitSpecialName ?? ''
                    } as OA_EquipoEspecial
                    lstOAKitSpecial.push(kitSpecial);
                }

            }


            tempCover['Nombre'] = nameCover.nombre;
            tempCover['orden'] = nameCover.orden;
            tempCover["IdCob"] = rate.idCob;
            tempCover["SA"] = rate.sa;
            tempCover["Prima"] = prima;//roundToTwo(parseFloat(rate.prima) * ((rate.pRecargo / 100) + 1));
            tempCover["ptasa"] = rate.pTasa;
            tempCover["pdescuento"] = porcenDescount;
            tempCover["mdescuento"] = desc;
            tempCover["pRecargo"] = 0;
            tempCover["mRecargo"] = 0;
            tempCover["mprimabruta"] = primaDE;
            tempCover["PrimaDE"] = primaDE;
            tempCover["Etiqueta"] = Etiqueta;
            tempCover["bDescuentoManual"] = 0;
            tempCover["PrimaGravada"] = primaDE
            tempCover["COA"] = rate.coa || 0
            tempCover["Deducible"] = rate.deducible || 0
            polCobs.push(tempCover);


            if (desc > 0) {
                polCobsDesc.push({
                    idCob: rate.idCob,
                    pdescuento: porcenDescount,
                    mdescuento: desc,
                    codDesc: idDesc,
                    fechaingreso: new Date()
                });
            }
        }
    });

    oa = {
        OA_EquipoEspecial: lstOAKitSpecial
    }

    policy['Respuesta'] = lstAnswers;
    policy['Beneficiarios'] = lstBeneficiary;
    policy['PolCobs'] = polCobs;
    policy['PolCobsDesc'] = polCobsDesc;
    policy['Au'] = au;
    policy['Oa'] = oa;
    policy['Asegurado'] = insured;
    policy['FormaPagos'] = {};

    return policy;
}

const validPrima = (value: any): number => {
    const num = Number(value);
    return isNaN(num) ? 0 : num;
}

const GetFinancing = (taxFinancing: any, bonus: number, quotas: string = '') => {
    let financing = 0
    if (taxFinancing !== undefined) {
        let taxP = taxFinancing.find((x: any) => x.frecuenciaPago === (quotas === '' ? 0 : parseInt(quotas)));
        if (taxP !== undefined)
            financing = roundToTwo((bonus * (parseFloat(taxP.porcentajeInteres) / 100)));
    }
    return financing;
}

const Assign = <T extends object, K extends keyof T>(obj: T, key: K, val: T[K]) => obj[key] = val


const isSpecialEquipment = (idCoverage: number) => coveragesSpecialEquipment.find((x: number) => x === idCoverage)

const BuildDataOportunity = (data: IAutoCR, source: string | null) => {
    const vehicleUse = data.catUse.find(x => x.value === data.vehicleUse)
    const vehicleDeductible = data.catDeductible.find(x => x.value === data.deductible)
    const vehicleDevice = catVehicleDevice.find(x => x.value === data.vehicleDevice)

    let auMarcaDesc = {} as ICatalog | undefined;
    if (data.vehicleBrand === '0')
        auMarcaDesc = data.catBranch.find((x: any) => x.value === data.otherVehicleBrand.trim());
    else
        auMarcaDesc = catVehicleBrand.find(x => x.value === data.vehicleBrand)
    let auModeloDesc = data.catModel.find((x: any) => x.value === data.vehicleModel.trim());

    // let vehicleValue = data.vehicleValue.toString()
    // const planConfig = data.lstPlanConfig.find(x => x.id === parseInt(data.plan));
    // if(planConfig !== undefined)
    //     vehicleValue =  formatMoney(planConfig.moneda, parseFloat(data.vehicleValue.toString()))

    //const resumen = GetResumen(data);

    const dataOportunity = {
        Sitio: SitioOportunity.CR.AutoCorreduria,
        NombreCompleto: `${data.firstName} ${data.lastName}`,
        Celular: data.phone,
        TipoIdentificacion: data.typeDocumentInsured,
        Identificacion: data.identificationInsured,
        Correo: data.mail,
        Edad: 0,
        OrigenOportunidad: source,
        IdPoliza: data.idPoliza,
        sucursal2_PCR: `P_${data.idBrokerage}`,
        Marca: auMarcaDesc?.text ?? '',
        Modelo: auModeloDesc?.description ?? '',
        Anio: data.vehicleYear,
        UsoVehiculo: vehicleUse?.text ?? '',
        EstadoVehiculo: data.vehicleStatus === "1" ? 'Nuevo' : 'Usado',
        NoOferta: data.idPoliza,
        ValorVehiculo: data.vehicleValue.toString(),
        Deducibles: vehicleDeductible?.text ?? '',
        Dispositivos: vehicleDevice?.text ?? '',
        NombreAsegurado: `${data.firstName} ${data.lastName}`,
        Importe: 0
    }
    return dataOportunity;
}

const BuildDataNotificationOportunitySL = (data: IAutoCR) => {
    const dataNotification = { sitio: SitioOportunity.CR.AutoCorreduria, values: {} }
    const plan = data.catPlanConfig.find(x => x.value === data.plan.toString());
    let namePlan = '';
    if (isValidObject(plan))
        namePlan = plan?.text ?? '';
    const values: Record<string, string> = {
        "__nombreplan__": namePlan,
        "__nombres__": `${data.firstName} ${data.lastName}`,
        "__correo__": data.mail,
        "__celular__": data.phone,
        "__oportunidad__": '',
    }
    dataNotification.values = values;
    return dataNotification;
}

const BuildNotificationCliente = (data: IAutoCR) => {
    const strCode = data.isEdit ? "MODIFICADO" : "NUEVO";
    const dataNotification = { sitio: SitioOportunity.CR.AutoCorreduria, codigo: strCode, values: {} }
    const values: Record<string, string> = {
        "idpoliza": data.idPoliza.toString(),
        "tiporeporte": 'ofe',
        "nombrereporte": 'Oferta',
        "correo": data.mail,
        "__nombres__": `${data.firstName} ${data.lastName}`
    }
    dataNotification.values = values;
    return dataNotification;
}

const IsPro = () => {
    const hostname = window.location.hostname;
    const isProductionCR = hostname.includes('appscr.seguroslafise.com');
    return isProductionCR;
}


export {
    IsValidString,
    GetDataByListPolicy,
    formatNumber,
    GetDataRates,
    Assign,
    isSpecialEquipment,
    GetResumen,
    BuilData,
    formatMoney,
    BuildDataOportunity,
    BuildDataNotificationOportunitySL,
    BuildNotificationCliente,
    IsPro
}